module.exports = __webpack_public_path__ + "static/media/managerPosterVideo.f5062741.PNG";